import { FileText } from 'lucide-react';

export function PaymentsTaxInfo({
  teacherName,
  last4Ssn,
  'data-testid': dataTestId,
}: {
  teacherName: string;
  last4Ssn: string | null | undefined;
  'data-testid'?: string;
}) {
  const maskedSsn = last4Ssn ? ` XXX-XX-${last4Ssn}` : '';

  return (
    <div className="flex items-center gap-2 text-sm text-gray-600 mb-4" data-testid={dataTestId}>
      <FileText className="h-4 w-4 flex-shrink-0" data-testid={dataTestId ? `${dataTestId}-icon` : undefined} />
      <p data-testid={dataTestId ? `${dataTestId}-text` : undefined}>
        <span className="block">
          Tax information: {teacherName}
          {maskedSsn}
        </span>
        <span className="block">
          Air Education Inc 548 Market St PMB 335427, San Francisco, California 94104-5401 US.
        </span>
      </p>
    </div>
  );
}
